import React, { useState, useEffect } from "react";
import { Grid, makeStyles, createStyles, Theme, Button, Box } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import * as CommonConstants from "utilities/CommonConstants";
import * as DbValueConstants from "utilities/DbValueConstants";
import { ConfigGetter } from "utilities/ConfigGetter";
import * as ConfigKey from "utilities/ConfigGetter";
import { DateUtil } from "utilities/DateUtil";
import { BookingApi } from "api/BookingApi";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Paths } from "Paths";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            marginRight: theme.spacing(5),
            marginLeft: theme.spacing(5),
            marginBottom: theme.spacing(1),
            textAlign: `center`,
        },
        title: {
            width: `50 !important`,
            height: `50`,
            textAlign: `center`,
            color: `white`,
            border: `1px solid`,
            padding: `5px`,
        },
        date: {
            // marginBottom: theme.spacing(2),
            textAlign: `center`,
        },
        cautions: {
            color: `black`,
            fontSize: `small`,
            border: `1px solid`,
            borderColor: `red`,
            display: `inline-block`,
            marginBottom: theme.spacing(3),
            padding: `10px`,
            paddingLeft: `30px`,
            paddingRight: `30px`,
        },
        message: {
            textAlign: `center`,
            marginBottom: theme.spacing(3),
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // イベント
    events: EventType[];
    // 予約設定
    setNewBooking: any;
    // ローディング状態のセッター
    setLoading: any;
    // 研究室で予約済みの予約情報
    targetBookingForLaboratoryCheck: EventType;
    // 二重予約警告リンク
    onClickLinkDoubleBooking: VoidFunction;
}

/**
 * 予約時間登録コンポーネント
 * 予約時間を登録するコンポーネント
 * @param props
 */
export const SelectBookingTime: React.FC<Props> = (props) => {
    const { booking, events, setNewBooking, setLoading, targetBookingForLaboratoryCheck, onClickLinkDoubleBooking } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    const [liquidWasteBookingalbeTime1, setLiquidWasteBookingalbeTime1] = useState<EventType[]>([]);
    const [liquidWasteBookingalbeTime2, setLiquidWasteBookingalbeTime2] = useState<EventType[]>([]);
    const [depositBookingalbeTime, setDepositBookingalbeTime] = useState<EventType[]>([]);

    // エラーメッセージ
    const [errorMessage, setErrorMessage] = useState<string>(``);

    useEffect(() => {
        const execute = async () => {
            // ローディング開始
            setLoading(true);
            const startTime = ConfigGetter.getNum(ConfigKey.BOOKING_START_TIME);
            // 予約可能時間を設定
            setLiquidWasteBookingalbeTime1(
                events.filter((e) => {
                    return (
                        e.id.includes(`${DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE}_`) &&
                        e.start.getHours() < startTime + 1
                    );
                })
            );
            setLiquidWasteBookingalbeTime2(
                events.filter((e) => {
                    return (
                        e.id.includes(`${DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE}_`) &&
                        e.start.getHours() >= startTime + 1
                    );
                })
            );
            setDepositBookingalbeTime(
                events.filter((e) => {
                    return e.id.includes(`${DbValueConstants.BOOKING_TYPE_ID_DEPOSIT}_`);
                })
            );

            // ローディング終了
            setLoading(false);
        };
        execute();
        // eslint-disable-next-line
    }, []);

    /**
     * 予約情報設定
     */
    const setBooking = async (id: string, start: Date, end: Date, bookingTypeId: number | undefined) => {
        // 予約枠が空いているかどうかチェック
        const result: any = await BookingApi.checkFree(start, end, bookingTypeId !== undefined ? bookingTypeId : 0);
        if (result?.status === 200 && !result.data?.success) {
            if (result.data?.errorMessage !== null) {
                setErrorMessage(result.data?.errorMessage);
            } else {
                setErrorMessage(result.errors?.errorMessage);
            }
            return;
        }
        booking.start = start;
        booking.end = end;
        booking.bookingTypeId = bookingTypeId;
        setNewBooking(id);
    };

    /**
     * 選択している予約時間の背景色取得
     */
    const getBackground = (start: Date, end: Date, bookingTypeId: number | undefined) => {
        let background = ``;
        if (
            bookingTypeId === DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE &&
            start === booking.start &&
            end === booking.end
        ) {
            background = CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE;
        } else if (
            bookingTypeId === DbValueConstants.BOOKING_TYPE_ID_DEPOSIT &&
            start === booking.start &&
            end === booking.end
        ) {
            background = CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT;
        }
        return background;
    };

    return (
        <div className={classes.form}>
            <p className="error">{errorMessage}</p>
            <h4 className={classes.date}>{DateUtil.parseViewDateForDialog(booking.start)}</h4>
            <div className={classes.cautions}>
                予約締切：廃液回収日前日の{ConfigGetter.get(ConfigKey.BOOKING_DEADLINE)}まで
            </div>
            {targetBookingForLaboratoryCheck.id !== `` && (
                <div className={classes.message}>
                    {targetBookingForLaboratoryCheck.subscriberLaboratoryName}は既に予約が入っています。
                    <br />
                    {DateUtil.parseViewDate(targetBookingForLaboratoryCheck.start, targetBookingForLaboratoryCheck.end)}
                <br />
                ※二重予約は出来ません。
                <br />
                日時を変更する場合はキャンセルをしてから再度予約してください
                </div>
            )}
            {isPcSize ? (
                <Grid container spacing={3} direction="row" justify="center" alignItems="stretch">
                    <Grid item md={6}>
                        <h6
                            className={classes.title}
                            style={{ background: CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE }}
                        >
                            {CommonConstants.BOOKING_TYPE_NAME_LIQUID_WASTE}　※付着物も含む
                        </h6>
                    </Grid>
                    <Grid item md={6}>
                        <h6
                            className={classes.title}
                            style={{ background: CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT }}
                        >
                            {CommonConstants.BOOKING_TYPE_NAME_DEPOSIT}
                        </h6>
                    </Grid>
                    <Grid item md={3}>
                        {liquidWasteBookingalbeTime1.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <Button
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE}`,
                                            background: getBackground(item.start, item.end, item.bookingTypeId),
                                            marginTop: '5px',
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </Button>
                                </Box>
                            );
                        })}
                    </Grid>
                    <Grid item md={3}>
                        {liquidWasteBookingalbeTime2.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <Button
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE}`,
                                            background: getBackground(item.start, item.end, item.bookingTypeId),
                                            marginTop: '5px',
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </Button>
                                </Box>
                            );
                        })}
                    </Grid>
                    <Grid item md={6}>
                        {depositBookingalbeTime.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <Button
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT}`,
                                            background: getBackground(item.start, item.end, item.bookingTypeId),
                                            marginTop: '5px',
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </Button>
                                </Box>
                            );
                        })}
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={3} direction="row" justify="center" alignItems="stretch">
                    <Grid item md={9}>
                        <h6
                            className={classes.title}
                            style={{ background: CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE }}
                        >
                            {CommonConstants.BOOKING_TYPE_NAME_LIQUID_WASTE}　※付着物も含む
                        </h6>
                        <Grid container spacing={3} direction="row" justify="center" alignItems="stretch">
                            <Grid item md={6}>
                                {liquidWasteBookingalbeTime1.map((item) => {
                                    return (
                                        <Box key={item.id}>
                                            <Button
                                                variant="outlined"
                                                style={{
                                                    border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE}`,
                                                    background: getBackground(item.start, item.end, item.bookingTypeId),
                                                    marginTop: '5px',
                                                }}
                                                onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                            >
                                                {DateUtil.parseViewTime(item.start, item.end)}
                                            </Button>
                                        </Box>
                                    );
                                })}
                            </Grid>
                            <Grid item md={6}>
                                {liquidWasteBookingalbeTime2.map((item) => {
                                    return (
                                        <Box key={item.id}>
                                            <Button
                                                variant="outlined"
                                                style={{
                                                    border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE}`,
                                                    background: getBackground(item.start, item.end, item.bookingTypeId),
                                                    marginTop: '5px',
                                                }}
                                                onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                            >
                                                {DateUtil.parseViewTime(item.start, item.end)}
                                            </Button>
                                        </Box>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={3}>
                        <h6
                            className={classes.title}
                            style={{ background: CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT }}
                        >
                            {CommonConstants.BOOKING_TYPE_NAME_DEPOSIT}
                        </h6>
                        {depositBookingalbeTime.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <Button
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT}`,
                                            background: getBackground(item.start, item.end, item.bookingTypeId),
                                            marginTop: '5px',
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </Button>
                                </Box>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
        </div>
    );
};
